import { render, staticRenderFns } from "./companySaleSettingsBox.vue?vue&type=template&id=55db8160&"
import script from "./companySaleSettingsBox.vue?vue&type=script&lang=ts&"
export * from "./companySaleSettingsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports